<template>
  <div class="party-building">
    <div class="head">
      <h3>党的建设</h3>
      <span @click="() => clickMore(53)">查看更多</span>
    </div>

    <van-swipe :autoplay="3000" :show-indicators="false">
      <van-swipe-item v-for="(item, index) in picList" :key="index">
        <div
          class="swipe-item"
          :style="{ backgroundImage: `url(${item.picturePath})` }"
          @click="() => clickMore(53)"
        >
          <div class="title" v-if="item.title">{{ item.title }}</div>
        </div>
      </van-swipe-item>
    </van-swipe>

    <div class="grid-ctn">
      <div @click="() => clickMore(37)">
        <div
          style="
            text-align: center;
            display: flex;
            flex-direction: column;
            font-size: 16px;
            line-height: 20px;
            white-space: nowrap;
          "
        >
          <p>“强国复兴有我”暨“喜迎二十大 说说新变化”</p>
          <p>群众性主题宣传教育活动</p>
        </div>
      </div>
      <div v-for="item in columns" :key="item.id" @click="() => onClickColumn(item.name, item.url)">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import codes from '@/api/codes';
import { configureParams } from '@/assets/js/configureParams';

export default {
  name: 'PartyBuilding',

  data() {
    return {
      // carouselData: [],
      picList: [],
      columns: [],
      clickTag1: codes.MENU, // 标记点击的是菜单
      clickTag2: codes.ARTICLE, // 标记点击的是新闻文章
    };
  },

  mounted() {
    // this.loadCarouselData();
    this.loadColumns();
    this.loadPics();
  },

  methods: {
    // loadCarouselData() {
    //   let replacement = {
    //     subjectId: 1,
    //     menuId: 95,
    //   };
    //   this.$api.getMenuArticle(replacement).then((res) => {
    //     this.carouselData = res.articleList.slice(0, 3);
    //   });
    // },
    /** 加载图片列表 */
    loadPics() {
      const replacement = {
        subjectId: 1,
      };
      Promise.all(
        [10].map((location) =>
          this.$api.getCarouselData(replacement, { location, pageId: 1, pageSize: 5 })
        )
      ).then(([arr1]) => {
        this.picList = [...arr1];
      });
    },

    /** 获取工会工作、青年工作栏目信息 */
    loadColumns() {
      const replacement = { subjectId: 1, menuId: 11 };
      this.$api.getNextLevelMenuInfo(replacement).then((res) => {
        this.columns = res.filter((item) => ['工会工作', '青年工作'].includes(item.name));
        console.log('this.columns : ', this.columns);
      });
    },

    onClickColumn(name, url) {
      if (name === '工会工作') window.open(url);
      else {
        this.clickMore(420);
      }
    },

    // 点击更多跳转到当前栏目
    clickMore(menuId) {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
        menuId,
      };
      this.$api.getMenuLevels(replacement).then((data) => {
        this.$router.push({
          path: '/content',
          query: configureParams(data, data, this.clickTag1),
        });
      });
    },

    // 点击新闻
    // clickNews(articleData) {
    //   let replacement = {
    //     subjectId: codes.SUBJECT_ID,
    //     articleId: articleData.id,
    //   };
    //   // this.$api.countClick(replacement)
    //   //   .then(data => {
    //   //     return this.$api.getArticleUpMenus(replacement)
    //   //   })
    //   // 获取文章的上级菜单结构
    //   this.$api.getArticleUpMenus(replacement).then((data) => {
    //     this.$router.push({
    //       path: '/content',
    //       query: configureParams(data, articleData, this.clickTag2),
    //     });
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.party-building {
  margin-top: 130px;
  padding: 73px 40px 118px;
  background-image: url('~@/assets/image/party-bg.jpg');

  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 60px;

    > h3 {
      font-size: 42px;
      font-weight: 500;
      color: #333333;
      line-height: 59px;
    }

    > span {
      font-size: 26px;
      font-weight: 400;
      color: #adadad;
      line-height: 37px;
    }
  }

  .swipe-item {
    height: 370px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;

    .title {
      position: absolute;
      bottom: 0;
      width: 100%;
      font-size: 28px;
      font-weight: 500;
      color: #ffffff;
      line-height: 40px;
      padding: 60px 30px 28px;
    }
  }

  .grid-ctn {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 239px 239px;
    row-gap: 20px;
    column-gap: 15px;

    > div {
      display: flex;
      align-items: center;
      color: #fff;
      font-weight: 500;

      &:first-child {
        grid-column-start: 1;
        grid-column-end: 3;
        background: center / cover no-repeat url('~@/assets/image/esdzt.jpg');
        justify-content: center;
      }

      &:nth-child(2) {
        background: center / cover no-repeat url('~@/assets/image/ghgz.jpg');
        padding-left: 45px;
        font-size: 27px;
      }
      &:last-child {
        background: linear-gradient(110deg, rgba(#8a0000, 0.8) 0%, rgba(#886464, 0%) 55%),
          center / cover no-repeat url('~@/assets/image/qngz.jpg');
        padding-left: 45px;
        font-size: 27px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/PartyBuilding.vue